import {
  components as defaultComponents,
  customShadows,
} from '@larvitu/shared/mui/feature-theme-provider';

import { components } from './components';
import { mixins } from './mixins';
import { palette } from './palette';
import { typography } from './typography';

import type { ThemeOptions } from '@mui/material';

export const theme: ThemeOptions = {
  palette,
  typography,
  components: {
    ...defaultComponents,
    ...components,
  },
  mixins,
  customShadows: customShadows.light,
};
